export default "__VITE_ASSET__D_7YWh4J__"